import { useContext } from 'react';
import { SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { ThemeColorMode } from '../enums';
export const useIsDarkMode = () => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  return isDarkMode;
};